import app from './app';
import user from './user';
import chat from './chat';
import botChat from './bot';
import video from './video';
import feedback from './feedback';
import linkBenefits from './link-benefits';
import scanAndPay from './scanAndPay';
import fitpass from './fitpass';

export default {
  app,
  user,
  chat,
  botChat,
  video,
  feedback,
  linkBenefits,
  scanAndPay,
  fitpass,
};
